import React, { useEffect } from "react";
import { Col, ListGroup, Row, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { RankUserDM } from "../../data_model/rank_user_dm";
import { StarLeaderboardDM } from "../../data_model/star_leaderboard_dm";
import ApiUtils from "../../utils/api_utils";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "./../../utils/route_pages";
import { priceDecimal } from "../../utils/utilities";
import { useNavigate } from "react-router-dom";

export const TopLeaderBoard = ({
  size = 4,
  name = "",
  star = "",
  tier_name = "",
  img_url = "",
  rank = 0,
}) => {
  return (
    <Col xs={size} sm={size} md={size}>
      <div className="top-leaderboard-detail">
        <img
          src={
            img_url
              ? ApiUtils.validateImgUrl({ url: img_url })
              : Assets.iconProfile
          }
          className="leaderboard-img"
          alt="card_item_image"
        />
        <div className="rank-badge">{rank}</div>
      </div>
      <div className="leaderboard-name">{name}</div>
      <div className="leaderboard-point">{star}</div>
      <div className="leaderboard-badge">{tier_name}</div>
    </Col>
  );
};

export const PositionLeaderBoard = ({
  rank = 1,
  img_url = "",
  name = "",
  tier_name = "",
  star = "",
}) => {
  return (
    <ListGroup>
      <ListGroup.Item>
        <Row>
          <Col xs={1} sm={1} md={1} className="leaderboard-no">
            {rank}
          </Col>
          <Col xs={3} sm={3} md={3}>
            <img
              src={
                img_url
                  ? ApiUtils.validateImgUrl({ url: img_url })
                  : Assets.iconProfile
              }
              className="leaderboard-image"
              alt="myvoucher_image"
            />
          </Col>
          <Col xs={5} sm={5} md={5}>
            <div className="leaderboard-name">{name}</div>
            <div className="leaderboard-level">{tier_name}</div>
          </Col>
          <Col xs={3} sm={3} md={3} className="leaderboard-total-star">
            {priceDecimal(star)} Stars
          </Col>
        </Row>
      </ListGroup.Item>
    </ListGroup>
  );
};

export const StarLeaderboard = (props) => {
  const navigate = useNavigate();
  const { getStarLeaderboard } = props;
  const start_leaderboard = StarLeaderboardDM.fromJson(props.start_leaderboard);

  useEffect(() => {
    getStarLeaderboard();
  }, []);
  return (
    <div className="leaderboard-star">
      <div className="leaderboard-title">Leaderboard</div>
      <Row className="top-leaderboard">
        {start_leaderboard.top_three_ranked_users.map((top, index) => {
          let ranked = RankUserDM.fromJson(top);
          return (
            <TopLeaderBoard
              key={`top-lead-${index}`}
              rank={ranked.rank}
              name={`${ranked.first_name} ${ranked.last_name}`}
              img_url={ranked.thumbnail_image_url}
              star={ranked.total_points_label}
              tier_name={ranked.tier_name}
            />
          );
        })}
      </Row>
      <Row className="position-leaderboard">
        {start_leaderboard.ranked_users.length > 3
          ? start_leaderboard.ranked_users.slice(0, 3).map((item, index) => {
              let ranked = RankUserDM.fromJson(item);
              return (
                <PositionLeaderBoard
                  key={`ranked-${index}`}
                  rank={ranked.rank}
                  name={`${ranked.first_name} ${ranked.last_name}`}
                  img_url={ranked.thumbnail_image_url}
                  star={ranked.total_points_label}
                  tier_name={ranked.tier_name}
                />
              );
            })
          : start_leaderboard.ranked_users.map((item, index) => {
              let ranked = RankUserDM.fromJson(item);
              return (
                <PositionLeaderBoard
                  key={`ranked-${index}`}
                  rank={ranked.rank}
                  name={`${ranked.first_name} ${ranked.last_name}`}
                  img_url={ranked.thumbnail_image_url}
                  star={ranked.total_points_label}
                  tier_name={ranked.tier_name}
                />
              );
            })}
        <Row className="leaderboard-button">
          <Button
            variant="outline-danger"
            className="btn-leaderboard-outline"
            onClick={() =>
              navigate(PageRoutes.leaderboard, {
                state: "stars",
              })
            }
          >
            See All Leaderboard
          </Button>
        </Row>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  start_leaderboard: state.ProfileSM.start_leaderboard,
});

const mapDispatchToProps = (dispatch) => ({
  getStarLeaderboard: dispatch.ProfileSM.getStarLeaderboard,
});

export default connect(mapStateToProps, mapDispatchToProps)(StarLeaderboard);
